import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { makeRebatesCalculationData, RebatesSummaryData } from "./types"
import { makeRebatesData } from "./utils"
import { usePolicyAndFleet } from "../../../contexts"
import { useApi } from "../../../contexts/hooks/useApi"

type Input = Readonly<{ id: string }>
type Output = RebatesSummaryData

export const rebateSummary = createRequest<Input, Output>(async (input, getToken) => {
  const calculations = await platform(getToken).policies.rebateCalculationPeriods(input)

  return makeRebatesCalculationData(makeRebatesData(calculations))
})

const useGetRebateSummary = createRequestHook(rebateSummary)

export const useRebateSummary = () => {
  const { policy } = usePolicyAndFleet()

  const [res, reload] = useGetRebateSummary({ id: policy.id })
  return useApi<Output, Input>(res, reload)
}
